import { useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "../../../../components/UI/Popover";
import { cn } from "../../../../utils/utils";
import SidebarFilters from "../SideBar/SidebarFilters";

/**
 * Single "Lọc nâng cao" button that collapses the 5 legacy advanced filter popups
 * (Sắp xếp / Loại / Quản lý / Tag / Tag Zalo) into one shared popover so the
 * top filter bar stays compact on smaller viewports.
 */
const AdvancedFilterButton = (props) => {
  const [open, setOpen] = useState(false);
  const activeCount =
    (props.selectedCategories?.length || 0) +
    (props.selectedTags?.length || 0) +
    (props.selectedTagZalos?.length || 0) +
    (props.selectedManagers?.length || 0) +
    (props.selectedPipelineStageIds?.length || 0) +
    (props.needsReplyMinutes ? 1 : 0) +
    (props.newCustomerDays ? 1 : 0) +
    (props.hasContactInfo ? 1 : 0) +
    (props.upcomingBirthdayDays ? 1 : 0) +
    (props.sortMode === "unread_first" ? 1 : 0);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className={cn(
            "inline-flex items-center gap-1 h-7 px-2.5 rounded-full border text-[12px] font-medium transition-colors whitespace-nowrap",
            activeCount > 0
              ? "bg-primary text-white border-primary"
              : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50",
          )}
          title="Lọc nâng cao"
        >
          <SlidersHorizontal size={12} />
          Lọc
          {activeCount > 0 && (
            <span
              className={cn(
                "ml-0.5 inline-flex items-center justify-center min-w-[16px] h-[16px] px-1 text-[10px] font-semibold rounded-full",
                "bg-white text-primary",
              )}
            >
              {activeCount}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto p-2 bg-white"
        side="bottom"
        align="end"
      >
        <div className="flex flex-col gap-2 min-w-[200px]">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 px-1">
            Lọc nâng cao
          </div>
          {/* Reuse the existing SidebarFilters — its 5 sub-popovers open inside
              this outer popover, which is fine because Radix portal-renders them. */}
          <div className="flex flex-row flex-wrap items-center gap-1.5">
            <SidebarFilters {...props} />
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default AdvancedFilterButton;
